export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-v1-480-6eeeafb64fc07cc1ac532d415f460868.png";